const React = require('react');

const { useState, createContext, useContext } = React;

const LiveDemoContext = createContext();

const LiveDemoContextProvider = ({ children, initialValues }) => {
  const [formData, setFormData] = useState(initialValues || {});
  const [behaviorData, setBehaviorData] = useState({
    showHomeSpinner: true,
    showLayoutSpinner: true,
    snackbarData: {
      show: false,
      message: '',
      type: 'green',
      delay: 3000,
    },
  });

  return (
    <LiveDemoContext.Provider
      value={
            {
              formData,
              setFormData,
              behaviorData,
              setBehaviorData,
            }
        }
    >
      {children}
    </LiveDemoContext.Provider>
  );
};

const useLiveDemoContext = () => {
  const context = useContext(LiveDemoContext);
  return {
    ...context,
  };
};

module.exports = { useLiveDemoContext, LiveDemoContextProvider };
